<router-outlet></router-outlet>

<app-snackbar-container style="pointer-events: none;"></app-snackbar-container>
